"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookmarkController = void 0;
const api_1 = require("@streem/api");
const analytics_1 = require("@streem/analytics");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const logger_1 = require("../../util/logger");
const utils_1 = require("../wall/utils");
const artifact_timed_deletion_1 = require("../../util/rx/artifact_timed_deletion");
const last_created_at_1 = require("../../util/rx/last_created_at");
const first_from_group_1 = require("../../util/rx/first_from_group");
class BookmarkController {
    constructor(config) {
        this.config = config;
        this.latestBookmarkTime = new streem_sdk_protobuf_1.Long(0);
        this.bookmarks = this.config.roomWall.itemsByType.pipe((0, utils_1.findInGroup)('artifact'), (0, utils_1.accumulateAndTransformWallEvents)('artifact'), (0, utils_1.filterByProperty)('artifactType', streem_sdk_protobuf_1.WallItem.ArtifactType.BOOKMARK), (0, operators_1.shareReplay)(1));
        this._bookmarkToSelect = new rxjs_1.BehaviorSubject(undefined);
        this.bookmarkToSelect = this._bookmarkToSelect.asObservable();
        // Pipe the latest bookmark into the bookmarkToSelect subject
        this.bookmarks
            .pipe(
        // Get the latest bookmark
        (0, last_created_at_1.lastCreatedAt)(), 
        // Only take newer bookmarks (as opposed to firing an older one after the latest bookmark is deleted)
        (0, operators_1.filter)((b) => {
            var _a, _b;
            return (!b ||
                (((_b = (_a = b === null || b === void 0 ? void 0 : b.bookmark) === null || _a === void 0 ? void 0 : _a.timestamp) === null || _b === void 0 ? void 0 : _b.seconds) || new streem_sdk_protobuf_1.Long(0)) > this.latestBookmarkTime);
        }), 
        // Save latest date on this controller... I'm sure there's a more rx-y way of doing this... -SA
        (0, rxjs_1.tap)((b) => {
            var _a, _b;
            this.latestBookmarkTime =
                ((_b = (_a = b === null || b === void 0 ? void 0 : b.bookmark) === null || _a === void 0 ? void 0 : _a.timestamp) === null || _b === void 0 ? void 0 : _b.seconds) || this.latestBookmarkTime;
        }))
            .subscribe(this._bookmarkToSelect);
        this.callStartTime = this.config.roomWall.itemsByType.pipe((0, utils_1.findInGroup)('artifact'), (0, utils_1.accumulateAndMapWallEvents)('artifact'), (0, utils_1.filterByProperty)('artifactType', streem_sdk_protobuf_1.WallItem.ArtifactType.RECORDING), (0, first_from_group_1.firstFromGroup)());
    }
    clearBookmarkToSelect() {
        this._bookmarkToSelect.next(undefined);
    }
    /**
     * Adds a bookmark to the wall
     */
    addBookmark(bookmark) {
        const response = this.config.roomWall.addBookmark({
            artifactType: streem_sdk_protobuf_1.WallItem.ArtifactType.BOOKMARK,
            bookmark: bookmark,
            status: streem_sdk_protobuf_1.WallItem.Artifact.Status.FULFILLED,
        });
        (0, analytics_1.recordArtifactFulfilled)(response);
        logger_1.logger.info(`added bookmark ${response} to wall`);
    }
    /**
     * Updates a bookmark on the wall
     */
    updateBookmark(bookmarkId, bookmark) {
        const response = this.config.roomWall.addBookmark({
            artifactType: streem_sdk_protobuf_1.WallItem.ArtifactType.BOOKMARK,
            bookmark: bookmark,
            status: streem_sdk_protobuf_1.WallItem.Artifact.Status.FULFILLED,
        }, bookmarkId);
        (0, analytics_1.recordArtifactUpdated)(response);
        logger_1.logger.info(`updated bookmark ${response} to wall`);
    }
    /**
     * Deletes a bookmark with a REST endpoint and from the wall
     */
    deleteBookmark(bookmarkId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield api_1.StreemAPI.rooms.deleteBookmark(this.config.context.roomId.toString(), bookmarkId);
                yield (0, artifact_timed_deletion_1.artifactTimedDeletion)(bookmarkId, this.bookmarks);
                (0, analytics_1.recordArtifactDeleted)({
                    artifactSid: bookmarkId,
                    roomSid: this.config.context.roomId.toString(),
                    bookmark: {},
                });
            }
            catch (e) {
                logger_1.logger.error(`error deleting bookmark ${bookmarkId}`, e);
            }
        });
    }
}
exports.BookmarkController = BookmarkController;
//# sourceMappingURL=bookmark_controller.js.map